import { StaysSearch } from 'modules/trips/components/StaysSearch/StaysSearch';
import { UpcomingTrips } from 'modules/trips/components/UpcomingTrips/UpcomingTrips';

export const TravelHomepage = () => {
  return (
    <div className="h-full overflow-auto px-40">
      <StaysSearch />
      <UpcomingTrips />
    </div>
  );
};
